export default "__VITE_ASSET__UzKhhw4f__"